<template>
	<sf-search-layout>
		<el-row :gutter="20">
			<el-col :span="4">
				<!-- 제목 -->
				<sf-input-group :label="getMessage_('SWCC000519')" :inputValue="title" :onChange="value => onChange('title', value)" />
			</el-col>
			<el-col :span="4">
				<!-- 내용 -->
				<sf-input-group :label="getMessage_('SWCC000520')" :inputValue="content" :onChange="value => onChange('content', value)" />
			</el-col>
			<el-col :span="4">
				<!-- 사용 유/무 -->
				<sf-select-group
					:label="getMessage_('SWCC000145')"
					:inputValue="useYn"
					:options="useYnOptions"
					:onChange="value => onChange('useYn', value)"
				/>
			</el-col>
		</el-row>
		<template slot="button">
			<sf-button line icon="search" :v-if="isButton_(scrId, 'CR')" :onClick="search">{{ getButtonMsg_(scrId, 'CR') }}</sf-button>
		</template>
	</sf-search-layout>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/Notification/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			title: '',
			content: '',
			useYn: 'Y',
			pageInit: true,
			screen: {}
		};
	},

	computed: {
		...serviceComputed,
		...rootComputed
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	watch: {
		//화면 정보 로딩시
		screen() {
			if (this.pageInit && this.screen.defaultPageSize && this.user.plantCd) {
				//페이지 정보 초기화
				this.setState_({
					key: 'notifications',
					value: { currentPage: 1, pageUnit: this.screen.defaultPageSize, data: [] }
				})
					.then(() => {
						this.pageInit = false;

						this.setUseYnList(); //사용 유무 공통 코드 selectBox option을 위한 리스트 조회
						this.search(); //공지사항 조회
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					});
			}
		},
		langCd() {
			this.setUseYnList(); //사용 유무 공통 코드 selectBox option을 위한 리스트 조회
		}
	},

	methods: {
		...serviceMethods,

		onChange(key, value) {
			this[key] = value;
			// alert(key);
			if (key === 'useYn') {
				this.search();
			}
		},

		//사용 유무 공통 코드 조회 Action 호출
		async setUseYnList() {
			this.$sf_toggleLoading(true);
			await this.getUseYnList_()
				.then(header => {
					//api 응답이 비정상일 경우만 알림 처리
					if (header.code !== 0) {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					}
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		//공지사항 조회 Action 호출
		async search() {
			this.$sf_toggleLoading(true);
			await this.select_({
				title: this.title,
				content: this.content,
				useYn: this.useYn,
				currentPage: 1,
				pageUnit: this.notifications.pageUnit
			})
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>

<style></style>
